import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import DoxExplorerFileOperationsMenu from './doxExplorerFileOperationsMenu'
import LoadingSpinnerSmall from '../../../../../../../src/components/library/loaders/LoadingSpinnerSmall';

const DoxExplorerFilesTableManageCell = (props) => {
    const handleFileOperation = (operation, documentId) => {
        props.onFileOperation(operation, documentId)
    }

    return (
        <div className={classnames('doxe-files-table-cell hrb-column manage', `hrb-is-${props.width}`)}
            style={{ justifyContent: props.justifyContent }}>
            {(props.isDownloading || props.isRecovering) &&
                <div className='hrb-column hrb-is-1 doxe-centered'>
                    <div className='doxe-centered doxe-menu-click-area'>
                        <LoadingSpinnerSmall />
                    </div>
                </div>
            }
            {!props.isDownloading && !props.isRecovering &&
                <DoxExplorerFileOperationsMenu documentId={props.documentId} onFileOperation={handleFileOperation} isSoftDeleted={props.isSoftDeleted} />
            }
        </div>
    )
}

DoxExplorerFilesTableManageCell.propTypes = {    
    width: PropTypes.number.isRequired,
    documentId: PropTypes.string.isRequired,
    onFileOperation: PropTypes.func.isRequired,
    isDownloading: PropTypes.bool.isRequired,
    justifyContent: PropTypes.string
}   

export default DoxExplorerFilesTableManageCell;